<template>
  <div data-testid="sentiment-rating-radio">
    <div
      v-for="option in options"
      :key="option.field"
    >
      <RadioInput
        :label="option.label"
        :model-value="value?.field"
        new-design
        :value="option.field"
        @update:model-value="onSelect(option)"
      >
        <span
          v-if="mentionSentimentOption?.field === option.field"
          class="tw:ml-2 tw:text-denim-700 tw:text-xs"
        >
          {{ getLocaleText("sentiment_widget.automated") }}
        </span>
      </RadioInput>
    </div>

    <slot name="helpText" />
  </div>
</template>

<script setup lang="ts">
import { getLocaleText } from "shared/boot/i18n";
import RadioInput from "shared/components/core/forms/RadioInput.vue";
import type { MentionSentimentOption } from "shared/composables/useMentionSentiment";

interface SentimentRatingRadioProps {
  mentionSentimentOption?: MentionSentimentOption;
  options: MentionSentimentOption[];
  value?: MentionSentimentOption;
}

defineProps<SentimentRatingRadioProps>();

const emit = defineEmits<{
  select: [option: MentionSentimentOption];
}>();

function onSelect(option: MentionSentimentOption): void {
  emit("select", option);
}
</script>
